'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _shopifySectionsManager = require('shopify-sections-manager');

var _shopifySectionsManager2 = _interopRequireDefault(_shopifySectionsManager);

var _Static = require('../sections/Static404');

var _Static2 = _interopRequireDefault(_Static);

require('intersection-observer');

var _rimgShopify = require('rimg-shopify');

var _rimgShopify2 = _interopRequireDefault(_rimgShopify);

require('../../styles/templates/404.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page404 = function Page404() {
  (0, _classCallCheck3.default)(this, Page404);

  var sections = window.shopifySections || new _shopifySectionsManager2.default();
  sections.register('static-404', function (section) {
    return new _Static2.default(section);
  });

  _rimgShopify2.default.init();
};

exports.default = Page404;


new Page404();